import React from 'react';
export function Footer() {
  return <footer className="bg-gray-100 py-8" data-id="element-18">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-600" data-id="element-19">
        <p className="mb-4" data-id="element-20">
          © 2023{' '}
          <strong data-id="element-21">
            <a href="https://www.neurotoned.com/41-off-neuro" className="text-teal-600 hover:text-teal-700" data-id="element-22">
              Neurotoned
            </a>
          </strong>
          . All rights reserved.
        </p>
        <div className="flex justify-center space-x-6" data-id="element-23">
          <a href="https://www.neurotoned.com/privacy-policy" className="hover:text-teal-600 transition-colors" data-id="element-24">
            Privacy Policy
          </a>
          <a href="https://www.neurotoned.com/terms-and-conditions" className="hover:text-teal-600 transition-colors" data-id="element-25">
            Terms of Service
          </a>
          <a href="https://www.neurotoned.com/contact-us" className="hover:text-teal-600 transition-colors" data-id="element-26">
            Contact Us
          </a>
        </div>
      </div>
    </footer>;
}